import React, { useContext, useEffect, useState } from "react";
import EmptyState from 'Components/DesignSystem/EmptyState/EmptyState';
import NoDataIllustration from 'Components/DesignSystem/EmptyState/NoDataIllustration';
import ServiceWrapper from "../../../Services/ServiceWrapper";
import AuthManager from "../../../Common/AuthManager";
import AppSettings from "../../../Settings/AppSettings";
import { AppContext } from "../../../Context/AppContext";
import Paginator from "../../Common/Paginator";
import Utils from "../../../Common/Utils";
import { useNavigate } from "react-router";
import Label from "../../Common/components/Label";
import { toast } from "Components/DesignSystem/Toast/useToast";
import GMSButton from "../../Common/components/GMSButton";
import TableSkeletonElement from "../Products/components/TableSkeletonElement";
import ChannelPreview from "./Components/ChannelPreview";
import { CSSTransition } from "react-transition-group";
import PromotionView from "./Components/PromotionView";
import GMSBorderlessButton from "../../Common/components/GMSBorderlessButton";
import "./Components/BuilderStyle.css";
import EyeIcon from "../../Common/components/EyeIcon";
import ExpandCollapseIcon from "../../Common/components/ExpandCollapseIcon";
import MenuIcon from "../../Common/components/MenuIcon";
import { formatDate } from "Common/HelperClass";


function BuilderListView(props) {
  const appData = useContext(AppContext);
  const navigate = useNavigate();
  const industryId = appData.selectedIndustry && appData.selectedIndustry.id;
  const [builderList, setBuilderList] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const [deleteBuilder, setDeleteBuilder] = useState(false);
  const [showList, setShowList] = useState(false);
  const [showChannel, setShowChannel] = useState(false);
  const [channelResponse, setChannelResponse] = useState(null);
  const [showBuilder, setShowBuilder] = useState(false);
  const [merchantKey, setMerchantKey] = useState("");
  const [showPromotion, setShowPromotion] = useState(false);
  const [builderTypeDetail, setBuilderTypeDetail] = useState({});
  const pageRange = 10;
  let [singlePageProducts, setSinglePageProducts] = useState([]);
  let [recordPerPage, setRecordPerPage] = useState(100);
  let [order, setOrder] = useState("");
  let [filteredBuildersList, setFilteredBuildersList] = useState(builderList);
  let [searchString, setSearchString] = useState("");
  const [token, setToken] = useState("");
  const [builderInfo, setBuilderInfo] = useState({
    id: "",
    name: "",
  });
  const [show, setShow] = useState(false);
  const [showRefresh, setShowRefresh] = useState({});
  let partyId = JSON.parse(localStorage.getItem("current_party_id"));
  let api_base_url = AppSettings.GMS_BACKEND_API_URL;

  useEffect(() => {
    if (appData.pm.checkPermission("gmskbcapps_view")) {
      if (industryId) {
        load_builder_by_industry();
        preview_channel();
      }
    } else {
      navigate("/workspace/module/permission/denied");
    }
  }, [industryId]);

  async function load_builder_by_industry() {
    setBuilderList(null);
    setShowList(false);
    let res = await ServiceWrapper.doGet(
      `${api_base_url}builder`,
      null,
      null,
      AuthManager.getGmsToken()
    );

    if (!res.errorfound) {
      if (res.data.done === true) {
        let builders = res.data.data;
        builders = builders.map((builder) => ({
          ...builder,
          showCopyIcon: false,
          expand: false,
        }));
        setBuilderList(builders);
        let showrefreshlist = {};
        for (let arr in res.data.data) {
          showrefreshlist[arr] = true;
        }
        setShowRefresh(showrefreshlist);
        setShowList(true);
      } else {
        toast.error(res.data.message);
        setShowList(true);
        setShowRefresh({});
      }
    } else {
      toast.error("Error Loading Builder List");
      setShowList(true);
    }
  }

  function handleClipbord(id) {
    navigator.clipboard.writeText(id).then(() => toast.success("UID copied"));
  }

  const refresh_builder = async (builderName, builderId, index) => {
    setRefresh(true);

    setShowRefresh({ ...showRefresh, [index]: false });
    let res = await ServiceWrapper.doGet(
      `${api_base_url}builder/${builderId}/refresh`,
      null,
      null,
      AuthManager.getGmsToken()
    );
    setRefresh(false);
    setShowRefresh({ ...showRefresh, [index]: true });
    if (res && !res.errorfound && res.data && res.data.done) {
      toast.success(`${builderName} Builder Refreshed.`);
    } else {
      toast.error("Something went wrong, Please try after some time.");
    }
  };

  async function handle_delete_Builder(builderId, builderType) {
    setDeleteBuilder(true);
    toast.info("Please wait while we delete selected Builder...");
    const builderObject = { version: builderType };
    let res = await ServiceWrapper.doDelete(
      api_base_url + "builder/" + builderId,
      builderObject,
      null,
      AuthManager.getGmsToken()
    );
    setDeleteBuilder(false);
    if (!res.errorfound) {
      if (res.data.done) {
        toast.success("Deletion successful.");
        load_builder_by_industry();
      } else {
        toast.error(`Error occurred while deleting. ${res.data.message}`);
      }
    } else {
      toast.error("Deletion failed due to some technical issue.");
    }
  }

  const handleToggle = () => {
    setShow((prev) => !prev);
  };

  async function handle_page_change(pagenumber, paged_data) {
    if (paged_data !== undefined) {
      setSinglePageProducts(paged_data);
    }
    await Utils.sleep(100);
  }

  function addBuilderBasedOnBuilderType(i, liveBuilder) {
    if (getLiveBuilder(i) !== null) {
      navigateToAddBuilder(liveBuilder?.uid, "Live");
    } else if (getDraftBuilder(i) != null) {
      navigateToAddBuilder(liveBuilder?.uid, "Draft");
    } else {
      navigateToAddBuilder(liveBuilder?.uid, "Rollback");
    }
  }

  useEffect(() => {
    if (searchString === "") {
      setFilteredBuildersList(builderList);
    }
  }, [builderList, searchString]);

  async function handleSearchAttribute(value) {
    setSearchString(value);
    if (!Utils.isEmpty(value)) {
      let searchval = value.toString().trim().toLowerCase();
      let filteredData = builderList.filter((item) => {
        if (item?.live === null && item?.rollback === null) {
          return item?.draft?.builder?.name.toLowerCase().includes(searchval);
        }
        if (item?.live !== null) {
          return item?.live?.builder?.name.toLowerCase().includes(searchval);
        }
        if (item?.rollback !== null) {
          return item?.rollback?.builder?.name
            .toLowerCase()
            .includes(searchval);
        }
        return (
          item?.name != null && item.name.toLowerCase().includes(searchval)
        );
      });

      setFilteredBuildersList(filteredData);
    }
  }

  function handleSortByColumn(columnName, orderValue) {
    if (order === "asc" || orderValue === "asc") {
      const sorted = [...singlePageProducts].sort((a, b) =>
        a[columnName].toLowerCase() > b[columnName].toLowerCase() ? 1 : -1
      );
      setSinglePageProducts(sorted);
      setOrder("desc");
    }

    if (order === "desc") {
      const sorted = [...singlePageProducts].sort((a, b) =>
        a[columnName].toLowerCase() < b[columnName].toLowerCase() ? 1 : -1
      );
      setSinglePageProducts(sorted);
      setOrder("asc");
    }
  }

  function navigateToAddBuilder(builderId, key) {
    navigate({
  pathname: `/gms/builder/detail/${builderId}`,
  search: `?version=${key ?? ""}`
});
  }

  async function preview_channel() {
    try {
      const res = await ServiceWrapper.doGet(
        `${api_base_url}party/${partyId}/channel`,
        null,
        null,
        AuthManager.getGmsToken()
      );

      if (res.data.done) {
        setChannelResponse(res.data.data);
      } else {
        console.log("handle error");
      }
    } catch (error) {
      console.error("Error caught ", error);
    }
  }

  const toggleExpanded = (index) => {
    let builders = [...singlePageProducts];
    builders[index].expand = !builders[index].expand;
    setBuilderList(builders);
  };

  function hasAtLeastTwoBuilders(builder) {
    let builderCount = 0;
    if (builder.live) {
      builderCount++;
    }
    if (builder.draft) {
      builderCount++;
    }
    if (builder.rollback) {
      builderCount++;
    }
    return builderCount >= 2;
  }

  function getBuilder(builder) {
    if (builder.live != null) {
      return builder.live;
    }

    if (builder.draft != null) {
      return builder.draft;
    }

    if (builder.rollback != null) {
      return builder.rollback;
    }
  }

  function getLiveBuilder(builder) {
    return builder?.live || null;
  }

  function getDraftBuilder(builder) {
    return builder?.draft || null;
  }

  function getRollbackBuilder(builder) {
    return builder?.rollback || null;
  }

  return (
    <React.Fragment>
      <div id="builder-list-page" data-testid="builder-list-page" className="ps-0 pe-0 pt-1">
        {!showBuilder && (
          <div className="border-bottom d-flex justify-content-between mb-3 pb-2 ps-3 row">
            <label
              id="builder-list-title"
              className="align-self-center col-md-2 fs-5 fw-bolder"
              style={{
                fontFamily: "Noto Sans",
              }}
            >
              Smart Builder
            </label>
            <div className="col-md-6 me-3 d-flex justify-content-end">
              <div className="col-md-5 d-flex">
                <input data-testid="builder-builderlist-input-1"
                  id="builder-search-input"
                  className="form-control p-2 shadow-none"
                  type="search"
                  placeholder="Search Builders..."
                  onChange={(e) => handleSearchAttribute(e.target.value)}
                  style={{
                    border: "1px solid rgb(216, 216, 220)",
                    fontSize: "0.875rem",
                    fontFamily: "Noto Sans",
                  }}
                />
              </div>
              <div className="px-2" />
              <GMSButton
                id="builder-btn-create"
                data-testid="builder-create-btn"
                name="Create Smart Builder"
                onClick={() => {
                  if (appData.pm.checkPermission("gmskbcapps_create")) {
                    // if (AuthManager.getPermissions().gmsadministration_editindustry) {
                    navigate({
  pathname: `/gms/builder/edit/0`
});
                  } else {
                    toast.info(
                      "You don't have permission to create the builder"
                    );
                  }
                }}
              />
            </div>
          </div>
        )}
        {
          !showList && (
            <div className="ms-3 me-3">
              <TableSkeletonElement />
            </div>
          )
          // <Loader />
        }
        {!showBuilder && showList && (
          <div className="row overflow-hidden" style={{ maxHeight: "100vh" }}>
            <div className="container-fluid overflow-hidden">
              {
                <>
                  <div className="container-fluid overflow-hidden">
                    <div className="row">
                      {singlePageProducts &&
                      filteredBuildersList &&
                      filteredBuildersList.length > 0 ? (
                        <div
                          className="table-responsive p-0"
                          style={{
                            maxHeight: "75vh",
                            borderRight: "2px solid #e6e6e6",
                            borderLeft: "2px solid #e6e6e6",
                            borderBottom: "1px solid #e6e6e6",
                          }}
                        >
                          <table id="builder-list-table" data-testid="builder-list-table" className="table ">
                            <thead className="custom-table-header">
                              <tr>
                                <th
                                  id="builder-header-name"
                                  className="align-middle ps-4 th-custom-style"
                                  scope="col"
                                  width="32%"
                                >
                                  <div role="button" data-testid="builder-builderlist-div-1"
                                    onClick={() => {
                                      if (order === "") {
                                        setOrder("asc");
                                        handleSortByColumn("name", "asc");
                                      } else {
                                        handleSortByColumn("name", "");
                                      }
                                    }}
                                  >
                                    <label
                                      style={{
                                        color: "#5c5f62",
                                      }}
                                    >
                                      Name
                                    </label>
                                    &nbsp;
                                    {order !== "" ? (
                                      <i
                                        className={`fas fa-sort-${
                                          order === "asc" ? "up" : "down"
                                        }`}
                                        style={{
                                          color: "#5c5f62",
                                        }}
                                      />
                                    ) : (
                                      <i
                                        className={"fas fa-sort"}
                                        style={{
                                          color: "#5c5f62",
                                        }}
                                      />
                                    )}
                                  </div>
                                </th>
                                <th
                                  id="builder-header-components"
                                  className="border-0 align-middle ps-4 th-custom-style"
                                  scope="col"
                                >
                                  <label
                                    style={{
                                      color: "#5c5f62",
                                    }}
                                  >
                                    Components
                                  </label>
                                </th>
                                <th
                                  id="builder-header-created-on"
                                  className=" align-middle ps-4 th-custom-style"
                                  scope="col"
                                >
                                  <label
                                    style={{
                                      color: "#5c5f62",
                                    }}
                                  >
                                    Created On
                                  </label>
                                </th>
                                <th
                                  id="builder-header-edited-on"
                                  className=" align-middle ps-4 th-custom-style"
                                  scope="col"
                                >
                                  <label
                                    style={{
                                      color: "#5c5f62",
                                    }}
                                  >
                                    Edited On
                                  </label>
                                </th>

                                <th
                                  id="builder-header-preview"
                                  className="ps-5 align-middle th-custom-style"
                                  scope="col"
                                >
                                  <label
                                    style={{
                                      color: "#5c5f62",
                                    }}
                                  ></label>
                                </th>

                                <th
                                  id="builder-header-actions"
                                  className=" ps-5 align-middle th-custom-style"
                                  scope="col"
                                >
                                  <label
                                    style={{
                                      color: "#5c5f62",
                                    }}
                                  ></label>
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {singlePageProducts.map((i, index) => {
                                const liveBuilder = getBuilder(i)?.builder;
                                const draftBuilder = i?.draft?.builder;
                                const rollbackBuilder = i?.rollback?.builder;

                                return (
                                  <React.Fragment
                                    key={index + getBuilder(i)?.builder?.name}
                                  >
                                    <tr
                                      id={`builder-row-${index}`}
                                      data-testid={`builder-row-${i?.id ?? index}`}
                                      className={`${
                                        i.expand ? "elevated" : ""
                                      }`}
                                      style={{
                                        textAlign: "left|center",
                                      }}
                                      key={i.id + index}
                                    >
                                      <td
                                        className={`ps-3 ${
                                          i.expand ? "elevated" : ""
                                        }`}
                                      >
                                        <div className="d-flex align-items-center">
                                          {hasAtLeastTwoBuilders(i) && (
                                            <div className="p-0">
                                              <ExpandCollapseIcon
                                                expand={i.expand}
                                                toggleExpanded={toggleExpanded}
                                                index={index}
                                              />
                                            </div>
                                          )}
                                          &nbsp; &nbsp;
                                          <div
                                            className=""
                                            onMouseEnter={() => {
                                              let builders = [
                                                ...singlePageProducts,
                                              ];
                                              builders[index].showCopyIcon =
                                                !builders[index].showCopyIcon;
                                              setBuilderList(builders);
                                            }}
                                            onMouseLeave={() => {
                                              let builders = [...builderList];
                                              builders[index].showCopyIcon =
                                                !builders[index].showCopyIcon;
                                              setBuilderList(builders);
                                            }}
                                            style={{
                                              height: "43",
                                              fontFamily: "Noto Sans",
                                              fontWeight: 400,
                                              cursor: "pointer",
                                              paddingLeft: `${
                                                !hasAtLeastTwoBuilders(i)
                                                  ? "24px"
                                                  : ""
                                              }`,
                                            }}
                                          >
                                            <label data-testid={`builder-builderlist-label-2-${index}`}
                                              id={`builder-row-${index}-name`}
                                              style={{
                                                cursor: "pointer",
                                                color: "#091CAA",
                                                fontWeight: "500",
                                              }}
                                              onClick={() => {
                                                addBuilderBasedOnBuilderType(
                                                  i,
                                                  liveBuilder
                                                );
                                              }}
                                            >
                                              {liveBuilder?.name}
                                            </label>
                                            &nbsp;
                                            <span
                                              className={`badge ps-2 pe-2 chip ${
                                                getLiveBuilder(i) !== null
                                                  ? "chip-live"
                                                  : getDraftBuilder(i) !== null
                                                    ? "chip-draft"
                                                    : "chip-old"
                                              }`}
                                            >
                                              {getLiveBuilder(i) !== null
                                                ? "Live"
                                                : getDraftBuilder(i) !== null
                                                  ? "Draft"
                                                  : "Old"}
                                            </span>
                                            <div className="d-flex">
                                              <label data-testid={`builder-builderlist-label-3-${index}`}
                                                style={{
                                                  cursor: "pointer",
                                                  fontWeight: "300",
                                                  fontSize: "0.7rem",
                                                }}
                                                onClick={() => {
                                                  addBuilderBasedOnBuilderType(
                                                    i,
                                                    liveBuilder
                                                  );
                                                }}
                                              >
                                                {liveBuilder?.uid}
                                              </label>
                                              &nbsp;&nbsp;
                                              {i.showCopyIcon && (
                                                <i data-testid={`builder-builderlist-i-4-${index}`}
                                                  className={`${"far"} fa-clipboard`}
                                                  style={{
                                                    fontSize: "0.95rem",
                                                    cursor: "pointer",
                                                    color: "#091caa",
                                                  }}
                                                  onClick={() =>
                                                    handleClipbord(
                                                      liveBuilder?.uid
                                                    )
                                                  }
                                                />
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                      </td>

                                      <td
                                        className={`ps-4 align-middle ${
                                          i.expand ? "elevated" : ""
                                        }`}
                                        style={{
                                          paddingLeft: "100px",
                                        }}
                                      >
                                        <label className="fw-normal fst-normal mb-0">
                                          {getBuilder(i)?.component}
                                        </label>
                                      </td>

                                      <td
                                        className={` align-middle ps-4 ${
                                          i.expand ? "elevated" : ""
                                        }`}
                                      >
                                        <Label
                                          message={formatDate(
                                            liveBuilder?.created_at
                                          )}
                                          fontSize="0.875"
                                          fontWeight="400"
                                          fontFamily="Noto Sans"
                                        />
                                      </td>

                                      <td
                                        className={` align-middle ps-4 ${
                                          i.expand ? "elevated" : ""
                                        }`}
                                      >
                                        <Label
                                          message={formatDate(
                                            liveBuilder?.updated_at
                                          )}
                                          fontSize="0.875"
                                          fontWeight="400"
                                          fontFamily="Noto Sans"
                                        />
                                      </td>

                                      <td
                                        className={` ps-4 align-middle ${
                                          i.expand ? "elevated" : ""
                                        }`}
                                      >
                                        <div className="d-flex align-items-center cursor-pointer tw-gap-1.5">
                                          <EyeIcon
                                            onClick={() => {
                                              if (channelResponse) {
                                                setShowChannel(
                                                  (prev) => (prev = !prev)
                                                );
                                                setBuilderInfo({
                                                  id: liveBuilder?.uid,
                                                  name: liveBuilder?.name,
                                                });
                                              } else {
                                                toast.error("No channel found");
                                              }
                                            }}
                                          />
                                          <GMSBorderlessButton
                                            id={`builder-row-${index}-btn-preview`}
                                            name="Preview"
                                            onClick={() => {
                                              if (channelResponse) {
                                                setShowChannel(
                                                  (prev) => (prev = !prev)
                                                );
                                                setBuilderInfo({
                                                  id: liveBuilder?.uid,
                                                  name: liveBuilder?.name,
                                                });
                                              } else {
                                                toast.error("No channel found");
                                              }
                                            }}
                                          />
                                        </div>
                                      </td>

                                      <td
                                        className={`ps-4 align-middle ${
                                          i.expand ? "elevated" : ""
                                        }`}
                                      >
                                        <div className="d-flex">
                                          &nbsp;&nbsp;&nbsp;
                                          <li
                                            className="nav-item dropdown"
                                            style={{ listStyleType: "none" }}
                                          >
                                            <div
                                              role="group"
                                              className="ps-3 pe-4 "
                                            >
                                              <i
                                                className=" pt-1 "
                                              />
                                              <MenuIcon />
                                              <ul
                                                id={`builder-row-${index}-menu`}
                                                className="dropdown-menu ps-0 pe-0 bg-white"
                                                style={{
                                                  fontFamily: "Noto Sans",
                                                  fontSize: "0.875rem",
                                                  textAlignLast: "center",
                                                }}
                                              >
                                                <li className="">
                                                  <GMSBorderlessButton
                                                    id={`builder-row-${index}-menu-btn-refresh`}
                                                    name="Refresh"
                                                    color="#000"
                                                    onClick={() => {
                                                      refresh_builder(
                                                        liveBuilder?.name,
                                                        liveBuilder?.uid,
                                                        index
                                                      );
                                                    }}
                                                  />
                                                </li>

                                                {getRollbackBuilder(i) !==
                                                  null && (
                                                  <li className="mt-1">
                                                    <GMSBorderlessButton
                                                      id={`builder-row-${index}-menu-btn-rollback`}
                                                      name="Rollback"
                                                      color="#000"
                                                      onClick={() => {
                                                        setShowPromotion(true);
                                                        setBuilderTypeDetail(i);
                                                      }}
                                                    />
                                                  </li>
                                                )}

                                                {/* <li className=" mt-1">
                                                  <GMSBorderlessButton
                                                    name="Delete"
                                                    color={"#000"}
                                                    onClick={() => {
                                                      if (
                                                        appData.pm.checkPermission(
                                                          "gmskbcapps_delete"
                                                        )
                                                      ) {
                                                        let builderType = "";
                                                        if (
                                                          getLiveBuilder(i) !==
                                                          null
                                                        ) {
                                                          builderType = "live";
                                                        } else if (
                                                          getDraftBuilder(i) !=
                                                          null
                                                        ) {
                                                          builderType = "draft";
                                                        } else {
                                                          builderType =
                                                            "rollback";
                                                        }
                                                        Bootbox.confirm(
                                                          "",
                                                          `${liveBuilder?.name}`,
                                                          false,
                                                          [
                                                            handle_delete_Builder,
                                                            liveBuilder?.uid,
                                                            builderType,
                                                          ]
                                                        );
                                                      } else {
                                                        toast.info(
                                                          "You don't have permission to delete the builder"
                                                        );
                                                      }
                                                    }}
                                                  />
                                                </li> */}
                                              </ul>
                                            </div>
                                          </li>
                                        </div>
                                      </td>
                                    </tr>
                                    {getLiveBuilder(i) !== null &&
                                      draftBuilder &&
                                      i.expand && (
                                        <tr
                                          data-expandable
                                          className=""
                                          style={{
                                            textAlign: "left|center",
                                            backgroundColor: "#FAFBFC",
                                          }}
                                        >
                                          <td className="ps-4">
                                            <div className="d-flex align-items-center">
                                              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                              <div role="button" data-testid={`builder-builderlist-div-5-${index}`}
                                                className=""
                                                onClick={() => {
                                                  //navigateToAddBuilder(i.id);
                                                }}
                                              >
                                                <label data-testid={`builder-builderlist-label-6-${index}`}
                                                  style={{
                                                    cursor: "pointer",
                                                    color: "#091CAA",
                                                    fontWeight: "500",
                                                  }}
                                                  onClick={() => {
                                                    navigateToAddBuilder(
                                                      draftBuilder?.uid,
                                                      "Draft"
                                                    );
                                                  }}
                                                >
                                                  {draftBuilder.name}
                                                </label>
                                                &nbsp;
                                                <span
                                                  className={`badge ps-2 pe-2 chip chip-draft`}
                                                >
                                                  {"Draft"}
                                                </span>
                                                &nbsp;
                                                {draftBuilder?.is_deleted && (
                                                  <span className="badge ps-2 pe-2 chip chip-deleted">
                                                    {"Deleted"}
                                                  </span>
                                                )}
                                                <div className="d-flex">
                                                  <label data-testid={`builder-builderlist-label-7-${index}`}
                                                    style={{
                                                      cursor: "pointer",
                                                      fontWeight: "300",
                                                      fontSize: "0.7rem",
                                                    }}
                                                    onClick={() => {
                                                      navigateToAddBuilder(
                                                        draftBuilder.id,
                                                        "Draft"
                                                      );
                                                    }}
                                                  >
                                                    {draftBuilder?.uid}
                                                  </label>
                                                </div>
                                              </div>
                                            </div>
                                          </td>

                                          <td
                                            className=" ps-4 align-middle"
                                            style={{
                                              //cursor: "pointer",
                                              paddingLeft: "100px",
                                            }}
                                          >
                                            <label className="fw-normal fst-normal mb-0">
                                              {i?.draft?.component}
                                            </label>
                                          </td>

                                          <td className=" align-middle ps-4">
                                            <Label
                                              message={formatDate(
                                                draftBuilder?.created_at
                                              )}
                                              fontSize="0.875"
                                              fontWeight="400"
                                              fontFamily="Noto Sans"
                                            />
                                          </td>

                                          <td className=" align-middle ps-4 ">
                                            <Label
                                              message={formatDate(
                                                draftBuilder?.updated_at
                                              )}
                                              fontSize="0.875"
                                              fontWeight="400"
                                              fontFamily="Noto Sans"
                                            />
                                          </td>

                                          <td className=" ps-4 align-middle ">
                                            <div className="d-flex align-items-center cursor-pointer">
                                              <EyeIcon
                                                onClick={() => {
                                                  if (channelResponse) {
                                                    setShowChannel(
                                                      (prev) => (prev = !prev)
                                                    );
                                                    setBuilderInfo({
                                                      id: draftBuilder?.id,
                                                      name: draftBuilder?.name,
                                                    });
                                                  } else {
                                                    toast.error(
                                                      "No channel found"
                                                    );
                                                  }
                                                }}
                                              />
                                              <GMSBorderlessButton
                                                name="Preview"
                                                onClick={() => {
                                                  if (channelResponse) {
                                                    setShowChannel(
                                                      (prev) => (prev = !prev)
                                                    );
                                                    setBuilderInfo({
                                                      id: draftBuilder?.id,
                                                      name: draftBuilder?.name,
                                                    });
                                                  } else {
                                                    toast.error(
                                                      "No channel found"
                                                    );
                                                  }
                                                }}
                                              />
                                            </div>
                                          </td>

                                          <td className=" ps-4 align-middle ">
                                            <div className="d-flex">
                                              &nbsp;&nbsp;&nbsp;
                                              <li
                                                className="nav-item dropdown"
                                                style={{
                                                  listStyleType: "none",
                                                }}
                                              >
                                                <div
                                                  role="group"
                                                  className="ps-3 pe-4 "
                                                >
                                                  <i
                                                    id="btnGroupDrop1"
                                                    className=" pt-1 "
                                                  />
                                                  <MenuIcon />
                                                  <ul
                                                    className="dropdown-menu ps-0 pe-0 bg-white"
                                                    aria-labelledby="btnGroupDrop1"
                                                    style={{
                                                      fontFamily: "Noto Sans",
                                                      fontSize: "0.875rem",
                                                      textAlignLast: "center",
                                                    }}
                                                  >
                                                    <li className="">
                                                      <GMSBorderlessButton
                                                        name="Refresh"
                                                        color="#000"
                                                        onClick={() => {
                                                          refresh_builder(
                                                            draftBuilder?.name,
                                                            draftBuilder?.uid,
                                                            index
                                                          );
                                                        }}
                                                      />
                                                    </li>

                                                    <li className="mt-1">
                                                      <GMSBorderlessButton
                                                        name="Publish"
                                                        color="#000"
                                                        onClick={() => {
                                                          //handleToggle();
                                                          setShowPromotion(
                                                            true
                                                          );
                                                          setBuilderTypeDetail(
                                                            i
                                                          );
                                                        }}
                                                      />
                                                    </li>

                                                    {/* <li className=" mt-1">
                                                    <GMSBorderlessButton
                                                      name="Delete"
                                                      color={"#000"}
                                                      onClick={() => {
                                                        if (
                                                          appData.pm.checkPermission(
                                                            "gmskbcapps_delete"
                                                          )
                                                        ) {
                                                          Bootbox.confirm(
                                                            "",
                                                            `${draftBuilder?.name}`,
                                                            false,
                                                            [
                                                              handle_delete_Builder,
                                                              draftBuilder?.uid,
                                                              "draft",
                                                            ]
                                                          );
                                                        } else {
                                                          toast.info(
                                                            "You don't have permission to delete the builder"
                                                          );
                                                        }
                                                      }}
                                                    />
                                                  </li> */}
                                                  </ul>
                                                </div>
                                              </li>
                                            </div>
                                          </td>
                                        </tr>
                                      )}
                                    {rollbackBuilder && i.expand && (
                                      <tr
                                        data-expandable
                                        className=""
                                        style={{
                                          textAlign: "left|center",
                                          backgroundColor: "#FAFBFC",
                                        }}
                                      >
                                        <td className="ps-4">
                                          <div className="d-flex align-items-center">
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            <div role="button" data-testid={`builder-builderlist-div-8-${index}`}
                                              className=""
                                              style={{
                                                height: "43",
                                                fontFamily: "Noto Sans",
                                                fontWeight: 400,
                                                cursor: "pointer",
                                              }}
                                              onClick={() => {
                                                //navigateToAddBuilder(i.id);
                                              }}
                                            >
                                              <label data-testid={`builder-builderlist-label-9-${index}`}
                                                style={{
                                                  cursor: "pointer",
                                                  color: "#091CAA",
                                                  fontWeight: "500",
                                                }}
                                                onClick={() => {
                                                  navigateToAddBuilder(
                                                    rollbackBuilder.uid,
                                                    "Rollback"
                                                  );
                                                }}
                                              >
                                                {rollbackBuilder.name}
                                              </label>
                                              &nbsp;
                                              <span className="badge ps-2 pe-2 chip chip-old">
                                                {"Old"}
                                              </span>
                                              {/* {rollbackBuilder.is_deleted && <span className="badge ps-2 pe-2 chip chip-deleted">
                                                {"Deleted"}
                                              </span>} */}
                                              <div className="d-flex">
                                                <label data-testid={`builder-builderlist-label-10-${index}`}
                                                  style={{
                                                    cursor: "pointer",
                                                    fontWeight: "300",
                                                    fontSize: "0.7rem",
                                                  }}
                                                  onClick={() => {
                                                    navigateToAddBuilder(
                                                      rollbackBuilder?.uid,
                                                      "Rollback"
                                                    );
                                                  }}
                                                >
                                                  {rollbackBuilder?.uid}
                                                </label>
                                              </div>
                                            </div>
                                          </div>
                                        </td>

                                        <td
                                          className="ps-4 align-middle"
                                          style={{
                                            paddingLeft: "100px",
                                          }}
                                        >
                                          <label className="fw-normal fst-normal mb-0">
                                            {i?.rollback?.component}
                                          </label>
                                        </td>

                                        <td className="align-middle ps-4">
                                          <Label
                                            message={formatDate(
                                              rollbackBuilder?.created_at
                                            )}
                                            fontSize="0.875"
                                            fontWeight="400"
                                            fontFamily="Noto Sans"
                                          />
                                        </td>

                                        <td className=" align-middle ps-4 ">
                                          <Label
                                            message={formatDate(
                                              rollbackBuilder.updated_at
                                            )}
                                            fontSize="0.875"
                                            fontWeight="400"
                                            fontFamily="Noto Sans"
                                          />
                                        </td>

                                        <td className=" ps-4 align-middle ">
                                          <div className="d-flex align-items-center cursor-pointer">
                                            <EyeIcon
                                              onClick={() => {
                                                if (channelResponse) {
                                                  setShowChannel(
                                                    (prev) => (prev = !prev)
                                                  );
                                                  setBuilderInfo({
                                                    id: rollbackBuilder?.uid,
                                                    name: rollbackBuilder?.name,
                                                  });
                                                } else {
                                                  toast.error(
                                                    "No channel found"
                                                  );
                                                }
                                              }}
                                            />
                                            <GMSBorderlessButton
                                              name="Preview"
                                              onClick={() => {
                                                if (channelResponse) {
                                                  setShowChannel(
                                                    (prev) => (prev = !prev)
                                                  );
                                                  setBuilderInfo({
                                                    id: rollbackBuilder?.uid,
                                                    name: rollbackBuilder?.name,
                                                  });
                                                } else {
                                                  toast.error(
                                                    "No channel found"
                                                  );
                                                }
                                              }}
                                            />
                                          </div>
                                        </td>

                                        <td className=" ps-4 align-middle ">
                                          <div className="d-flex">
                                            &nbsp;&nbsp;&nbsp;
                                            <li
                                              className="nav-item dropdown"
                                              style={{ listStyleType: "none" }}
                                            >
                                              <div
                                                role="group"
                                                className="ps-3 pe-4 "
                                              >
                                                <i
                                                  id="btnGroupDrop1"
                                                  className=" pt-1 "
                                                />
                                                <MenuIcon />
                                                <ul
                                                  className="dropdown-menu ps-0 pe-0 bg-white"
                                                  aria-labelledby="btnGroupDrop1"
                                                  style={{
                                                    fontFamily: "Noto Sans",
                                                    fontSize: "0.875rem",
                                                    textAlignLast: "center",
                                                  }}
                                                >
                                                  <li className="">
                                                    <GMSBorderlessButton
                                                      name="Refresh"
                                                      color="#000"
                                                      onClick={() => {
                                                        refresh_builder(
                                                          rollbackBuilder.name,
                                                          rollbackBuilder.uid,
                                                          index
                                                        );
                                                      }}
                                                    />
                                                  </li>

                                                  <li className="mt-1">
                                                    <GMSBorderlessButton
                                                      name="Rollback"
                                                      color="#000"
                                                      onClick={() => {
                                                        setShowPromotion(true);
                                                        setBuilderTypeDetail(i);
                                                      }}
                                                    />
                                                  </li>

                                                  {/* <li className=" mt-1">
                                                    <GMSBorderlessButton
                                                      name="Delete"
                                                      color={"#000"}
                                                      onClick={() => {
                                                        if (
                                                          appData.pm.checkPermission(
                                                            "gmskbcapps_delete"
                                                          )
                                                        ) {
                                                          Bootbox.confirm(
                                                            "",
                                                            `${draftBuilder.name}`,
                                                            false,
                                                            [
                                                              handle_delete_Builder,
                                                              rollbackBuilder?.uid,
                                                              "rollback",
                                                            ]
                                                          );
                                                        } else {
                                                          toast.info(
                                                            "You don't have permission to delete the builder"
                                                          );
                                                        }
                                                      }}
                                                    />
                                                  </li> */}
                                                </ul>
                                              </div>
                                            </li>
                                          </div>
                                        </td>
                                      </tr>
                                    )}
                                  </React.Fragment>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                    ) :
                    (
                    /* DS EmptyState (2026-09-08): was the fixed-colour <img alt="logo">
                       + a 24px #091caa label — navy on dark, invisible. Testid kept. */
                    <EmptyState
                      title="No Data Found"
                      illustration={<NoDataIllustration />}
                      data-testid="builder-empty-message"
                    />
                    )
                  }
                    </div>
                    <div className="mt-3">
                      {filteredBuildersList &&
                        filteredBuildersList.length > 0 && (
                          <div className="d-flex justify-content-end">
                            &nbsp;
                            <select data-testid="builder-builderlist-select-2"
                              className="form-select form-select-sm"
                              style={{ width: "70px" }}
                              aria-label="Default select example"
                              defaultValue={100}
                              onChange={(e) => setRecordPerPage(e.target.value)}
                            >
                              <option value={10}>10</option>
                              <option value={20}>20</option>
                              <option value={50}>50</option>
                              <option value={100}>100</option>
                              <option value={200}>200</option>
                              <option value={500}>500</option>
                              <option value={10000}>All</option>
                            </select>
                            &nbsp;
                            <Paginator
                              recordPerPage={recordPerPage}
                              totalRecords={filteredBuildersList.length}
                              data={filteredBuildersList}
                              pageRange={pageRange}
                              onPageChange={handle_page_change}
                              simple={true}
                            />
                          </div>
                        )}
                    </div>
                    {showChannel && channelResponse && (
                      <CSSTransition
                        timeout={1000}
                        key={showChannel}
                        classNames={{
                          enterActive: "animate__animated animate__flipInX",
                          exitActive: "animate__animated animate__flipOutX",
                        }}
                      >
                        <ChannelPreview
                          channelResponse={channelResponse}
                          setShowChannel={setShowChannel}
                          setShowBuilder={setShowBuilder}
                          setMerchantKey={setMerchantKey}
                          platformInfo={appData.platformInfo}
                          setToken={setToken}
                        />
                      </CSSTransition>
                    )}
                    {showPromotion && (
                      <CSSTransition
                        timeout={1000}
                        key={showPromotion}
                        classNames={{
                          enterActive: "animate__animated animate__flipInX",
                          exitActive: "animate__animated animate__flipOutX",
                        }}
                      >
                        <PromotionView
                          setShowPromotion={setShowPromotion}
                          builders={builderTypeDetail}
                          refreshBuilder={load_builder_by_industry}
                        />
                      </CSSTransition>
                    )}
                  </div>
                </>
              }
            </div>
          </div>
        )}
        {showBuilder && builderInfo.id && (
          <div className="w-100 h-100 p-0 m-0">
            <div className="col card">
              <div className="d-flex pb-0 pt-0 justify-content-between align-items-center">
                <div style={{ float: "left", zIndex: 6 }}>
                  <i data-testid="builder-builderlist-i-11"
                    id="btnGroupDrop1"
                    className="fas fa-angle-left pt-1 pe-2"
                    style={{
                      fontSize: "1rem",
                      cursor: "pointer",
                      color: "#5c5f62",
                    }}
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    onClick={() => {
                      setShowBuilder((prev) => (prev = !prev));
                    }}
                  />
                  <Label
                    message={builderInfo?.name ?? "Builder"}
                    fontSize={1.125}
                    fontWeight="700"
                  />
                </div>
              </div>
            </div>
            <div className="d-flex w-100">
              <iframe
                style={{ height: "80vh", width: "inherit" }}
                //src={`https://apps.compat.io/?merchantKey=iuX5FUzHpou813o5B30m&builderModel=39c23b6c01f311ed96492a9f4261eaf9&authToken=l9LcJuS8h6AOXsWErPX5SfmcETfmzJQXEjIDd&variantId=37564033171631`}
                //src={`https://apps.compat.io/?merchantKey=${merchantKey}&builderModel=${builderHeaderDetails.uid}&authToken=${token}`}
                src={`https://apps.compat.io/?builderModel=${builderInfo.id}&merchantKey=${merchantKey}&authToken=${token}`}
                id="iframe_view_builder"
                title="Product Builder"
                allow="clipboard-read; clipboard-write"
              />
            </div>
          </div>
        )}
      </div>
    </React.Fragment>
  );
}

export default BuilderListView;
